import { render, staticRenderFns } from "./sync-tools.vue?vue&type=template&id=5aa6b9b0"
import script from "./sync-tools.vue?vue&type=script&lang=js"
export * from "./sync-tools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports